import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import NavLink from 'components/V2/NavLink';
import { connect } from 'react-redux';
import { clearV2Form } from 'redux/ducks/Post/actions';
import {
  triggerBlockedFailedPaymentModal,
  triggerWaitUntilFailedPaymentProcessModal,
} from 'redux/ducks/Modals';
import {
  blockedByFailedPayment,
  pendingUnblockFailedPayment,
  showBlockedFailedPaymentPopups,
} from 'helpers/payment';

class SideNavBar extends Component {
  onClickCreateEvent = () => {
    const { user } = this.props;

    if (pendingUnblockFailedPayment(user)) {
      this.props.toggleWaitUntilFailedPaymentProcess();
      return;
    }

    if (blockedByFailedPayment(user)) {
      this.props.toggleBlockedForFailedPayments();
      return;
    }
  };

  redirectLinkUrl = () => {
    const { user } = this.props;

    return user.userPersona ? '/v2/create-event/setting' : '/v2/create-event/persona';
  };

  render() {
    const { user, authenticated } = this.props;

    return (
      <nav className="sideNavBar">
        {user.role === 'Event operator' && (
          <div className="create-job">
            {showBlockedFailedPaymentPopups(user) && !user.failedPaymentBlockOverride ? (
              <button onClick={this.onClickCreateEvent} className="btn btn-primary">
                Create New Job
              </button>
            ) : (
              <Link
                className="btn btn-primary"
                to={this.redirectLinkUrl}
                onClick={() => {
                  this.props.clearV2Form();
                }}
              >
                Create New Job
              </Link>
            )}
          </div>
        )}
        <ul className={authenticated ? 'links' : 'links unauthed-links'}>
          {this.props.links &&
            this.props.links.map((link, index) => {
              return <NavLink key={index} link={link} />;
            })}
        </ul>
      </nav>
    );
  }
}

NavLink.contextTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  router: PropTypes.object,
};

const mapStateToProps = state => ({
  user: state.session.currentUser,
});

const mapDispatchToProps = dispatch => ({
  clearV2Form: () => dispatch(clearV2Form()),
  toggleBlockedForFailedPayments: () => dispatch(triggerBlockedFailedPaymentModal()),
  toggleWaitUntilFailedPaymentProcess: () => dispatch(triggerWaitUntilFailedPaymentProcessModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideNavBar);
